export default {
  velt: {
    openPanel: 'فتح لوحة التعليقات',
    closePanel: 'إغلاق لوحة التعليقات',
    panel: 'لوحة التعليقات',
    tabs: 'علامات تبويب لوحة التعليقات',
    comments: 'التعليقات',
    settings: 'الإعدادات والأذونات',
    dragOrTapComment: 'اسحب لإضافة تعليق، أو انقر لعرض التعليقات',
    assignComment: 'تعيين تعليق',
    markAsUnread: 'وضع علامة كغير مقروء',
    markAsRead: 'وضع علامة كمقروء',
    unsubscribe: 'إلغاء الاشتراك',
    subscribe: 'اشتراك',
    deleteThread: 'حذف الموضوع',
    editComment: 'تعديل التعليق',
    emptyPlaceholder: 'قدّم ملاحظات، أو اطرح سؤالاً، أو اترك ملاحظة لأعضاء فريقك',
    searchPlaceholder: 'البحث في التعليقات',
    commentPlaceholder: 'علّق على {page}',
    replyPlaceholder: 'رد....',
    filterPages: 'الصفحات',
    filterAuthor: 'المؤلف',
    filterTagged: 'المُشار إليهم',
    statusOpen: 'مفتوح',
    statusResolved: 'تم الحل',
    anonymous: 'مجهول',
    settingsPanel: {
      title: 'من يمكنه التعليق؟',
      everyoneLabel: 'الجميع',
      restrictedLabel: 'المتعاونون المدعوون فقط',
      emailsLabel: 'رسائل البريد الإلكتروني',
      emailsPlaceholder: 'أضف بريدًا إلكترونيًا واضغط Enter',
    },
  },
}
